import { lazy } from "react";

export const Login = lazy(() => import("./login"));
export const Dashboard = lazy(() => import("./dashboard"));
export const Leads = lazy(() => import("./leads"));
export const LeadDetail = lazy(() => import("./lead-detail"));
export const Tasks = lazy(() => import("./tasks"));
export const Token = lazy(() => import("./token"));
export const CallRecord = lazy(() => import("./call-record"));
export const Customer = lazy(() => import("./customer"));
export const Project = lazy(() => import("./admin/project"));
export const Source = lazy(() => import("./admin/source"));
export const Users = lazy(() => import("./admin/users"));
export const ImportLead = lazy(() => import("./import/import-lead"));
export const ExportLead = lazy(() => import("./admin/export"));
export const LeadRequest = lazy(() => import("./admin/lead-request"));
export const TokenDetail = lazy(() => import("./token-detail"));
export const Inventory = lazy(() => import("./inventory"));
export const InventoryDetail = lazy(() => import("./inventory-detail"));
export const AnalysisAndReports = lazy(() => import("./analysis-and-reports"));
export const ImportInventory = lazy(() => import("./import/import-inventory"));
export const StaffTargets = lazy(() => import("./staff-targets"));

export const StaffTargetDetail = lazy(() => import("./staff-target-detail"));
export const IndividualProperties = lazy(
  () => import("./individual-properties"),
);
export const TaskDetail = lazy(() => import("./task-detail"));

export const ProjectDetail = lazy(() => import("./project-detail"));

export const MessengerApp = lazy(() => import("./messenger"));

export const TeamPage = lazy(() => import("./teams/team"));

export const TeamDetailPage = lazy(() => import("./teams/team-detail"));

export const UserDetail = lazy(() => import("./teams/user-detail"));

export const WhatsappApp = lazy(() => import("./whatsapp"));

export const Unauthorized = lazy(() => import("./un-authorized"));

export const IndividualPropertiesImport = lazy(
  () => import("./import/import-individual-property"),
);

export const Activities = lazy(() => import("./activities"));
export const SalesPage = lazy(() => import("./sales"));
export const LeadsKanban = lazy(() => import("./lead-kanban-view"));
export const SkipList = lazy(() => import("./admin/skip-list"));
